/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {  makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import {
    arrayOf, bool, number, object, shape, string,
} from 'prop-types';
import { getPriceRangeLayout } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import findContent from '../../../../../../../../gql/queries/findContent';
import PriceBreakdownDetail from './PriceBreakdownDetail';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getCurrentPageType } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';

const useStyles = makeStyles(() => ({
    container: {
        position: 'relative',

    },
    wrapperRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: '16px',
        '& $dialog': {
            left: 'unset',
            right: '16px',
            '@media screen and (max-width: 440px)': {
                width: '100%',
            },
        },
    },
    messageCopy: {
        color: '#434343',
        fontSize: '14px',
        lineHeight: '20px ',
        letterSpacing: '0.5px',
        cursor: 'pointer',
        textDecoration: 'underline',
        textDecorationThickness: '1px',
        textUnderlineOffset: '3px',
        paddingBottom: '5px',
        '@media screen and (max-width: 768px)': {
            fontSize: '12px',
        },
    },
    popperRoot: {
        zIndex: 9999,
    },
    wrapperPDP: {
        paddingRight: '0px',
    },
    messageHierarchyCopy: {
        fontSize: '14px',
        lineHeight: '18px',
        paddingBottom: '5px',
        letterSpacing: 'normal',
        color: '#555555',
        '@media only screen and (max-width: 768px)': {
            lineHeight: '16px !important',
            fontSize: '12px !important',
        },
    },
    wrapUpRedesignCopy: {
        lineHeight: '19px',
        '@media only screen and (max-width: 768px)': {
            lineHeight: '17px',
        },
    },
}));

const PriceBreakDownUi = ({
    dynamicPriceData, skuPriceRange, isCaDelivery,
}) => {
    const classes = useStyles();
    const pageType = useSelector(getCurrentPageType);
    const dispatch = useDispatch();

    const priceRangeLayout = useSelector(getPriceRangeLayout);
    const productType = dynamicPriceData?.productType?.toLowerCase?.() === 'fpt' ? 'fpt' : 'standard';
    const isDynamicEnabled = dynamicPriceData?.prices?.[0]?.displayCharges || false;

    const findContentOptions = {
        brand: 'global',
        contentType: 'ca_product_messaging',
    };

    /**
     * Data will ge get from Apollo cache! It won't query multiple times
     */
    const PRICE_MESSAGE_INFORMATION = findContent(findContentOptions);
    const { data, loading, error } = useQuery(PRICE_MESSAGE_INFORMATION);
    const cmsPricingData = data?.findContent?.content?.entries || [];
    const productDeliveryType = productType === 'fpt' ? 'fpt' : 'Standard';

    const priceMessaging = (cmsPricingData?.[0]?.brand || []).find((item) => item.brand_id === dynamicPriceData?.brand || isCaDelivery) || {};

    useEffect(() => {
        const caDeliverFee = sessionStorage.getItem('caDeliveryFee');
        if (!caDeliverFee) {
            dispatch(trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'CA All-In Pricing',
                eventLabel: isCaDelivery ? 'Variant' : 'Control',
                feature_detail: isCaDelivery ? 'Variant' : 'Control',
                feature_element: 'CA All-In Pricing',
                feature_category: 'Experiment',
                queued: !!(typeof window !== 'undefined' && !window.utag?.data),
                nonInteraction: true,
            }));
            sessionStorage.setItem('caDeliveryFee', true);
        }
    }, [isCaDelivery]);

    if (loading) {
        return <></>;
    }

    if (error && !data && !loading) {
        return <></>;
    }

    if (!isDynamicEnabled || !isCaDelivery) {
        return <></>;
    }

    return (
        <div className={`${classes.container}  ${classes.wrapperPDP} `}>
            <PriceBreakdownDetail
                dynamicPriceData={dynamicPriceData}
                priceMessaging={priceMessaging}
                productDeliveryType={productDeliveryType}
                priceRangeLayout={priceRangeLayout}
                skuPriceRange={skuPriceRange}
            />
        </div>
    );
};

PriceBreakDownUi.propTypes = {
    dynamicPriceData: object.isRequired,
    isCaDelivery: bool,
    skuPriceRange: shape({
        retail: arrayOf(shape({
            value: number,
        })),
        sale: arrayOf(shape({
            value: number,
        })),
    }),
};
PriceBreakDownUi.defaultProps = {
    isCaDelivery: false,
    skuPriceRange: {},
};
export default PriceBreakDownUi;
